import { env } from '$env/dynamic/public';
import { fetchAuthSession } from 'aws-amplify/auth';
import { CognitoJwtVerifier } from 'aws-jwt-verify';

export async function verifyJwt(token: string, tokenUse: 'id' | 'access' = 'id') {
	const verifier = CognitoJwtVerifier.create({
		userPoolId: env.PUBLIC_COGNITO_USER_POOL_ID ?? '',
		clientId: env.PUBLIC_COGNITO_CLIENT_ID ?? '',
		tokenUse
	});
	return verifier.verify(token);
}

export async function getUser(): Promise<UserStore> {
	try {
		const { tokens } = await fetchAuthSession();
		if (!tokens?.idToken)
			return {
				signedIn: false
			};
		const { nickname, email } = await verifyJwt(tokens.idToken.toString(), 'id');
		return {
			signedIn: true,
			nickname: nickname?.toString(),
			email: email?.toString()
		};
	} catch (error) {
		return {
			signedIn: false
		};
	}
}

export async function authenticatedFetch(input: RequestInfo | URL, init?: RequestInit) {
	const { tokens } = await fetchAuthSession();
	if (!tokens?.accessToken) throw new Error('No accessToken found');

	const headers = new Headers(init?.headers);
	headers.set('Authorization', `Bearer ${tokens.accessToken.toString()}`);

	return fetch(input, { ...init, headers });
}

export async function getWatchlist(): Promise<Populated<BaseWatchlist>> {
	return authenticatedFetch('/private/watchlist')
		.then((res) => res.json())
		.then((data) => {
			return data;
		});
}
